/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const timeEntryValidationMetadata: ModelValidationMetadataMap = {
  TimeEntry: {
    properties: {
      job: {
        required: true,
        displayName: 'Job',
      },
      timeCategory1: {
        required: true,
        displayName: 'Category',
      },
      timeTotal: {
        required: true,
        displayName: 'Amount'
      },
      notes: {
        maxLength: 2000,
        displayName: 'Notes'
      }
    }
  }
};
